<template>
  <div>
    <!-- <CreateTerminal
      v-if="branch"
      :branchId="branch.id"
      :companyId="
        $route.query.companyId ? $route.query.companyId : branch.companyId
      "
    /> -->
    <!-- <ReAssignPOSModal
      :modalData="modalData"
      :branch="branch.id"
      :fromBranch="true"
      v-if="branch"
    /> -->
    <MasterLayout>
      <div
        class="fuelbalance_first_row row mx-auto"
        style="justify-content: center; width: 96%"
      >
        <div
          class="fuelbalance_first_row_right_section asset_card col-md-7 py-5 col-sm-12"
        >
          <div class="our__branches__banner">
            <div
              class="row align-items-center d-flex justify-content-left section__row"
            >
              <div class="col-md-8">
                <div class="ml_5">
                  <h5 class="primary-color">
                    {{ $t("text.iMasterLayout.hi") }}, {{ userName }}
                  </h5>
                  <div class="mt-3">
                    <span class="primary-color">{{
                      $t("text.bTerminal.description")
                    }}</span>
                  </div>
                </div>
              </div>

              <!-- create terminal -->

              <!-- <div class="col-md-4 text_right">
                <button class="btn details_btn" @click="createTerminal">
                  {{ $t("text.bTerminal.createTerminal") }}
                </button>
              </div> -->
            </div>
          </div>
        </div>

        <section class="col-md-5 col-sm-12">
          <div class="card_container grid-col-6">
            <div class="row align-items-center fuel_consumption_buttons_row">
              <div class="mt-3 col-md-6 col-sm-12 fuel_consumption_btn_div">
                <div
                  class="fuel_consumption_button active_tab"
                  style="height: 80px; width: 80px"
                >
                  <h3 class="text-white">{{ linkedTerminalNumber }}</h3>
                </div>
                <div class="mt-3 text-center bold-text primary-color">
                  {{ $t("text.retainership.linkedTerminals") }}
                </div>
              </div>

              <div class="mt-3 col-md-6 col-sm-12 fuel_consumption_btn_div">
                <div
                  class="fuel_consumption_button active_tab"
                  style="height: 80px; width: 80px"
                >
                  <h3 class="text-white">{{ nonLinkedTerminalNumber }}</h3>
                </div>
                <div class="mt-3 text-center bold-text primary-color">
                  {{ $t("text.retainership.nonLinkedTerminals") }}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div class="row mt-3">
        <section class="col-md-12 col-lg-8">
          <div class="d-flex ml-4 py-2 tabs">
            <div
              @click="() => (this.tabLinked = true)"
              class="mr-4 tab"
              :class="tabLinked && 'activeTab'"
            >
         
            {{ $t("text.retainership.linkedTerminals") }}
            </div>

            <div
              @click="() => (this.tabLinked = false)"
              class="tab"
              :class="!tabLinked && 'activeTab'"
            >
              {{ $t("text.retainership.nonLinkedTerminals") }}
            </div>
          </div>
        </section>

        <section v-show="tabLinked" class="col-md-12 col-lg-4">
          <vue-ctk-date-time-picker
            v-model="dateRange"
            :max-date="maxDate"
            :range="true"
            :autoClose="true"
            :custom-shortcuts="customShortcuts"
            color="#4b2c72"
            format="DDMMYYYY"
            formatted="DD/MM/YYYY"
            :label="$t('text.calendar.dateRange')"
          />
        </section>
      </div>

      <section class="pump__details__section_2">
        <div class="row add_driver_row record__expenses">
          <div class="col-md-12 col-lg-12 mt-3" v-show="!showLoader">
            <ejs-grid
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :allowTextWrap="true"
              :locale="usedLang"
              :rowSelected="rowSelected"
              :dataSource="tabLinked ? linkedTerminals : nonLinkedTerminals"
            >
              <e-columns>
                <e-column width="80" field="index" headerText="#"></e-column>

                <e-column
                  width="250"
                  :template="TerminalTemp"
                  :headerText="$t('text.bTerminal.terminalId')"
                ></e-column>

                <e-column
                  width="200"
                  field="serialNo"
                  :headerText="$t('text.bTerminal.serialNo')"
                ></e-column>
                <e-column
                  width="190"
                  field="vendor"
                  :headerText="$t('text.cBank.terminal2.vendor')"
                ></e-column>

                <e-column
                  v-if="tabLinked"
                  width="150"
                  field="total"
                  :headerText="$t('text.salesTransactions.total')"
                ></e-column>
                <e-column
                  v-if="tabLinked"
                  width="150"
                  field="success"
                  :headerText="$t('text.omit.successful')"
                ></e-column>
                <e-column
                  v-if="tabLinked"
                  width="150"
                  field="failed"
                  :headerText="$t('text.omit.failed')"
                ></e-column>
                <!-- <e-column
                  width="150"
                  field="transactionLimit"
                  :headerText="$t('text.posRevamp.transactionLimit')"
                ></e-column>
                <e-column
                  width="180"
                  field="fee"
                  :headerText="$t('text.posRevamp.fee')"
                ></e-column>
                <e-column
                  width="200"
                  field="balance"
                  :headerText="$t('text.cBank.transaction.balance')"
                ></e-column> -->

                <!-- <e-column
                  :template="terminalTemplate"
                  :headerText="$t('text.actionButtons.title')"
                  width="330"
                ></e-column> -->
              </e-columns>
            </ejs-grid>
          </div>
          <div class="col-md-12 col-lg-12 mt-3">
            <TableLoader :showLoader="showLoader" />
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import backgroundUrl from "@/assets/img/Credit-card-background-shallow-DOF.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import ReAssignPOSModal from "@/components/modals/POS/reAssignPOS.vue";
import CreateTerminal from "@/components/modals/POS/createTerminal.vue";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";
import GetAsset from "@/components/modals/Assets/getAsset.vue";
import Paginator from "@/components/Paginator.vue";
import Temp from "@/components/Templates/createBranchTerminal.vue";
import TerminalTemp from "@/components/Templates/terminalTemp";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "POS Terminals :: Epump Portal",
  name: "Assets",
  components: {
    MasterLayout,
    // AssetDetails,
    GetAsset,
    Paginator,
    TableLoader,
    ReAssignPOSModal,
    CreateTerminal,
    TerminalTemp,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      linkedTerminalNumber: 0,
      nonLinkedTerminalNumber: 0,
      linkedTerminals: [],
      nonLinkedTerminals: [],
      tabLinked: true,
      asset: {},

      addAssetId: "",
      fromDate: null,
      toDate: null,
      branches: [],
      status: "allStatus",
      isActive: "selectActive",
      assetData: {},
      tableCount: 0,
      first: true,
      pageSize: "10",
      totalPages: 1,
      currentPage: 1,
      sortType: "",
      sortColumn: "",
      assetNumber: "",
      userDetails: localStorage.getItem("userDetails")
        ? JSON.parse(localStorage.getItem("userDetails"))
        : null,
      // company: localStorage.getItem("companyDetails")
      //         ? JSON.parse(localStorage.getItem("companyDetails"))
      //         : null,
      backgroundUrl,
      cardBackgroundUrl,
      groupAssets: [],
      showLoader: true,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["Search"],
      search: { operator: "contains", ignoreCase: true },
      terminalCount: 0,
      modalData: {},
      branch: null,
      branchId: "",
      terminalTemplate: function () {
        return {
          template: Temp,
        };
      },
      TerminalTemp: function () {
        return {
          template: TerminalTemp,
        };
      },

      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],

      formatOptions: { type: "date", format: "dd/MM/yyyy" },
      // startDate: this.$moment().subtract(7, "days").format("MMMM D, YYYY"),
      startDate: this.$moment().format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      // pluginStartDate: this.$moment().subtract(7, "days").format("D-M-YYYY"),
      pluginStartDate: this.$moment().format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
    };
  },
  computed: {
    userName() {
      return `${this.userDetails.firstName} ${this.userDetails.lastName}`;
    },
  },

  created() {
    this.dateRange.start = this.pluginStartDate;
    this.dateRange.end = this.pluginEndDate;
    this.$router.replace({
      name: this.$route.name,
      query: {
        branchId: this.$route.query.branchId
          ? this.$route.query.branchId
          : this.branch.id,
        groupId: this.$route.query.groupId,
        regionId: this.$route.query.regionId,
        dealerId: this.$route.query.dealerId,
        companyId: this.$route.query.companyId,
        startDate: this.$moment(this.pluginStartDate, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        ),
        endDate: this.$moment(this.pluginEndDate, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        ),
      },
    });

    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
      document.title = `POS Terminals:: ${branch.name} Retail Outlet`;
    });

    if (this.branch) {
      this.$eventHub.$on("_createTerminal", (data) => {
        this.modalData = data;
        this.$modal.show("createTerminal");
      });
    }

    this.$eventHub.$on("refreshTerminalsList", () => {
      this.getTerminals();
      this.getNotLinkedTerminals();
    });

    this.$eventHub.$on("_reAssignPOSModal", (data) => {
      this.modalData = data;
      this.$modal.show("reAssignPOS");
    });

    //Delete POS

    // this.$eventHub.$on("_deletePOS", (data) => {
    //   this.deletePOS(data);
    // });
  },

  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
    if (this.branch) {
      this.getTerminals();
      this.getNotLinkedTerminals();
    }
  },

  watch: {
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        console.log("first");

        this.$router.replace({
          name: this.$route.name,
          query: {
            branchId: this.$route.query.branchId
              ? this.$route.query.branchId
              : this.branch.id,
            groupId: this.$route.query.groupId,
            regionId: this.$route.query.regionId,
            dealerId: this.$route.query.dealerId,
            companyId: this.$route.query.companyId,
            startDate: this.startDate,
            endDate: this.endDate,
          },
        });

        console.log("second");

        this.getTerminals();
      }
    },

    branch: function (newBranch, oldBranch) {
      if (newBranch.id) {
        // this.branchId = this.branch.id;

        if (this.branch) {
          this.getTerminals();
          this.getNotLinkedTerminals();
        }
      }
    },
  },

  beforeDestroy() {
    this.$eventHub.$off("setAssetModalValue");
  },

  methods: {
    //requests

    getNotLinkedTerminals() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Pos/Terminals?branchId=${this.branch.id}`,
          configObject.authConfig()
        )
        .then((res) => {
          res.data = res.data.filter((el) => !el.linked);

          res.data.sort((a, b) => {
            return a.balance > b.balance ? 1 : b.balance > a.balance ? -1 : 0;
          });
          let index = 0;
          res.data.forEach((el) => {
            el.index = ++index;
            el.vendor = el.vendor ? el.vendor : "N/A";

            el.fee = this.convertThousand(el.fee);
            el.balance = this.convertThousand(el.balance);
          });

          // this.$refs.dataGrid.ej2Instances.setProperties({
          //   dataSource: res.data,
          // });

          this.nonLinkedTerminals = res.data.filter((el) => !el.linked);

          this.nonLinkedTerminalNumber = this.nonLinkedTerminals.length;

          this.refreshGrid();

          this.showLoader = false;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },

    getTerminals() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.posBaseUrl}/Pos/branch/${this.branch.id}?startDate=${
            this.$route.query.startDate
              ? this.$route.query.startDate
              : this.startDate
          }&endDate=${
            this.$route.query.endDate ? this.$route.query.endDate : this.endDate
          }`,
          configObject.remisConfig()
        )
        .then((res) => {
          let index = 0;
          res.data.sort((a, b) => {
            return a.vendor.toLowerCase() > b.vendor.toLowerCase()
              ? 1
              : b.vendor.toLowerCase() > a.vendor.toLowerCase()
              ? -1
              : 0;
          });
          res.data.forEach((el) => {
            el.index = ++index;
            el.fee = this.convertThousand(el.fee);
            el.balance = this.convertThousand(el.balance);
            el.total = `${this.convertThousand(el.transactionAmount)} (${
              el.transactionCount
            })`;
            el.success = `${this.convertThousand(el.successfulAmount)} (${
              el.successfulCount
            })`;
            el.failed = `${this.convertThousand(el.failedAmount)} (${
              el.failedCount
            })`;
          });
          // this.terminalCount = res.data.length;
          this.linkedTerminals = res.data;
          this.linkedTerminalNumber = this.linkedTerminals.length;
          // this.$refs.dataGrid.ej2Instances.setProperties({
          //   dataSource: res.data,
          // });
          this.refreshGrid();
          this.showLoader = false;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },

    // deletePOS(data) {
    //   const remove = confirm(this.$t("text.omit.deleteTerminal"));
    //   if (!remove) {
    //     return;
    //   }
    //   this.axios
    //     .delete(
    //       `${configObject.apiBaseUrl}/Pos/DeleteTerminal/DeleteTerminal/${data.id}`,
    //       configObject.authConfig()
    //     )
    //     .then((res) => {
    //       this.$toast.open({
    //         message: this.$t("text.omit.terminalDeleted"),
    //         type: "success",
    //         duration: 4000,
    //       });
    //       this.getTerminals();
    //     })
    //     .catch((error) => {
    //       this.$toast.open({
    //         message: error.response.data.message,
    //         type: "error",
    //         duration: 4000,
    //       });
    //     });
    // },

    //modal
    createTerminal() {
      this.$modal.show("createTerminal");
    },

    //utilities

    rowSelected: function (args) {
      const data = args.data;
      // console.log(data);
      // this.$router.push({
      //   name: "branch-pos-terminals-details",
      //   query: {
      //     terminalId: data.terminalId,
      //     branchId: data.branchId,
      //     companyId: data.companyId,
      //   },
      // });
    },

    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },

    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>

<style scoped>
.tab {
  color: #4c2e73;
  padding: 0px 6px;
  font-weight: 500;
  cursor: pointer;
}

.activeTab {
  padding-bottom: 6px;
  border-bottom: 3px solid;
}
</style>
